import { memo } from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
{/* barra de progreso en la parte de abajo */}
const SurveyProgressBar = memo(({ questionCount, maxQuestions, t }) => {
  const pct   = Math.min((questionCount / maxQuestions) * 100, 100);
  const color = pct >= 100 ? 'error' : pct >= 80 ? 'warning' : 'primary';

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        px: 3,
        py: 1,
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.08)',
      }}
    >
      <Box sx={{ maxWidth: 'lg', mx: 'auto' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
          <Typography variant="caption" color="text.secondary" fontWeight={500}>
            {t.questionsProgressLabel}
          </Typography>
          <Typography
            variant="caption"
            fontWeight={700}
            color={pct >= 100 ? 'error.main' : pct >= 80 ? 'warning.main' : 'primary.main'}
          >
            {questionCount} / {maxQuestions}
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={pct}
          color={color}
          sx={{ height: 6, borderRadius: 3, bgcolor: 'grey.200', transition: 'value 0.4s ease' }}
        />
        {pct >= 100 && (
          <Typography variant="caption" color="error.main" sx={{ mt: 0.5, display: 'block' }}>
            {t.questionsLimitReached}
          </Typography>
        )}
      </Box>
    </Box>
  );
});

SurveyProgressBar.displayName = 'SurveyProgressBar';

export default SurveyProgressBar;